'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.changePassword = exports.getResetEmail = exports.reset = undefined;

var _http = require('../../utils/services/http');

var _http2 = _interopRequireDefault(_http);

var _httpConstants = require('../../../common/utils/http/httpConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reset = exports.reset = function reset(email) {
    var resetConfig = {
        method: _httpConstants.METHODS.POST,
        url: 'auth/password/reset',
        data: {
            email: email.toLowerCase()
        }
    };

    return (0, _http2.default)(resetConfig);
};

var getResetEmail = exports.getResetEmail = function getResetEmail(code) {
    var getResetConfig = {
        method: _httpConstants.METHODS.GET,
        url: 'auth/password/code/' + code
    };

    return (0, _http2.default)(getResetConfig).then(function (response) {
        return response.data.email;
    });
};

var changePassword = exports.changePassword = function changePassword(_ref) {
    var email = _ref.email,
        code = _ref.code,
        password = _ref.password;

    var changePasswordConfig = {
        method: _httpConstants.METHODS.PUT,
        url: 'auth/password/change',
        data: {
            email: email,
            code: code,
            password: password
        }
    };

    return (0, _http2.default)(changePasswordConfig);
};


//////////////////
// WEBPACK FOOTER
// ./src/client/auth/password/passwordService.js
// module id = 672
// module chunks = 0